import NiceModal from '@ebay/nice-modal-react';

import { Trans, useTranslation } from 'react-i18next';

import Image from 'components/global/Image';
import Typography from 'components/global/Typography';

import PrivacyPolicyModal from 'pages/Login/PrivacyPolicyModal';

import * as S from './styled/SmsFooter.styled';

const LinkViewer = ({ children, onClick, errors }) => {
	const { t } = useTranslation();
	return (
		<Typography
			color={errors?.aggreedTerms ? 'var(--red)' : 'var(--blue)'}
			onClick={onClick}
			style={{ textDecoration: 'underline', display: 'inline', cursor: 'pointer' }}
			noWrap>
			{t(children)}
		</Typography>
	);
};

const SmsFooter = () => (
	<S.Container>
		<Typography color="var(--content-3)">poweredBy</Typography>
		<Image
			width={'3rem'}
			height="3rem"
			url={'https://storage.googleapis.com/tryoto-public/public/assets/images/otoLogo.png'}
		/>
		<S.Divider></S.Divider>
		<Typography color="var(--content-3)">
			<Trans
				i18nKey={`readOtoPrivacyPolicy`}
				components={{
					linkViewer: (
						<LinkViewer
							onClick={(e) => {
								NiceModal.show(PrivacyPolicyModal);
								e.stopPropagation();
							}}
						/>
					)
				}}
			/>
		</Typography>
	</S.Container>
);
export default SmsFooter;
